<h3>Payment Method Error</h3>
<p>There has been an error validating your payment method. Please try again, or contact us for further support.</p>
<div mat-dialog-actions>
  <button class="btn-theme btn btn-lg" mat-dialog-close="">Close</button>
</div>
